"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationDecoders = exports.responseDecoders = exports.decodeOrReturnOriginal = exports.RemoteNotifications = exports.Methods = exports.SubmitCodeResult = exports.SubmitCodeOutput = exports.SubmitCodeParams = exports.SctResult = exports.RunCodeResult = exports.RunCodeOutput = exports.RunCodeParams = exports.BackendError = exports.Language = void 0;
const zod_1 = require("zod");
exports.Language = zod_1.z.union([zod_1.z.literal('java'), zod_1.z.literal('rust')]);
exports.BackendError = zod_1.z.object({
    error: zod_1.z.string(),
    type: zod_1.z.literal('backend-error'),
});
exports.RunCodeParams = zod_1.z.object({
    code: zod_1.z.string(),
    language: exports.Language,
});
exports.RunCodeOutput = zod_1.z.object({
    output: zod_1.z.string(),
    type: zod_1.z.union([zod_1.z.literal('output'), zod_1.z.literal('error')]),
});
exports.RunCodeResult = zod_1.z.union([exports.RunCodeOutput, exports.BackendError]);
exports.SctResult = zod_1.z.object({
    correct: zod_1.z.boolean(),
    message: zod_1.z.string(),
});
exports.SubmitCodeParams = zod_1.z.object({
    code: zod_1.z.string(),
    language: exports.Language,
    sct: zod_1.z.string(),
});
exports.SubmitCodeOutput = zod_1.z.object({
    runResult: exports.RunCodeOutput,
    sctResult: exports.SctResult,
    type: zod_1.z.literal('output'),
});
exports.SubmitCodeResult = zod_1.z.union([exports.SubmitCodeOutput, exports.BackendError]);
exports.Methods = {
    runCode: {
        params: exports.RunCodeParams,
        result: exports.RunCodeResult,
    },
    submitCode: {
        params: exports.SubmitCodeParams,
        result: exports.SubmitCodeResult,
    },
};
exports.RemoteNotifications = {};
function decodeOrReturnOriginal(schema) {
    const decoder = (value) => {
        const result = schema.safeParse(value);
        if (!result.success) {
            return value;
        }
        return result.data;
    };
    return decoder;
}
exports.decodeOrReturnOriginal = decodeOrReturnOriginal;
exports.responseDecoders = {
    runCode: decodeOrReturnOriginal(exports.Methods.runCode.result),
    submitCode: decodeOrReturnOriginal(exports.Methods.submitCode.result),
};
exports.notificationDecoders = {};
//# sourceMappingURL=index.js.map